// src/ui/Typography.jsx
import React from "react";

const baseTextColor = { color: "var(--mudo-text)" };
const mutedColor = { color: "var(--mudo-text-muted)" };

export function HeadingXL({ children, className = "" }) {
  return (
    <h1
      className={`font-sans text-3xl sm:text-4xl font-bold tracking-tight ${className}`}
      style={baseTextColor}
    >
      {children}
    </h1>
  );
}

export function PageTitle({ children, className = "" }) {
  return (
    <h1
      className={`font-sans text-2xl sm:text-3xl font-semibold leading-tight ${className}`}
      style={baseTextColor}
    >
      {children}
    </h1>
  );
}

export function SectionTitle({ children, className = "" }) {
  return (
    <h2
      className={`font-sans text-xl font-semibold leading-snug ${className}`}
      style={baseTextColor}
    >
      {children}
    </h2>
  );
}

export function BodyText({ children, className = "" }) {
  return (
      <p
        className={`font-sans text-base leading-relaxed ${className}`}
        style={baseTextColor}
      >
        {children}
      </p>
  );
}

export function SmallText({ children, className = "" }) {
  return (
    <p
      className={`font-sans text-sm leading-snug ${className}`}
      style={mutedColor}
    >
      {children}
    </p>
  );
}

export function LabelText({ children, className = "" }) {
  return (
    <span
      className={`font-sans text-[11px] uppercase tracking-wide ${className}`}
      style={mutedColor}
    >
      {children}
    </span>
  );
}

// Journal keeps its script feel only for body text; headings/buttons stay on base font.
export function JournalBody({ children, className = "" }) {
  return (
    <p
      className={`text-base leading-relaxed font-['JournalScript',cursive] ${className}`}
      style={baseTextColor}
    >
      {children}
    </p>
  );
}
